import React, { Fragment, useRef, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import Filters from '../filters';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import GatsbyImage from 'components/GatsbyImage/GatsbyImage';
import Contact from './contact';
import Bio from './bio';
import PRESS from 'src/utils/pressConstants';
import styles from './news.module.scss';
import { useStaticQueryGetAuctions } from 'services/graphql/queries/auctions';
import moment from 'moment';
import {
  getUpcomingAuctions,
  getUpcomingSubEvent,
} from 'services/graphql/queries/auctions/formatedAuctions';
import { getEventDateAverage } from 'shared/helpers/auctions';

const News = ({
  bio,
  posts,
  pageData,
  pageNumber,
  totalNumberOfPages,
  changePage,
  tab,
  location,
}) => {
  useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault(); // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById('my-component');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    // remove the event listener when the component is unmounted

    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  if (typeof window !== 'undefined') {
    document.addEventListener('contextmenu', e => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
  const { subEventAuction } = useStaticQueryGetAuctions({
    todayDate: moment().format('YYYY-MM-DDTHH:mm'),
  });
  const validSubEvents =
    subEventAuction?.length && getUpcomingSubEvent(subEventAuction);

  const auctions =
    validSubEvents?.length &&
    getUpcomingAuctions(validSubEvents)
      .filter(
        auction =>
          auction.webpage__auction && auction.eventStatus !== 'EventCancelled'
      )
      .map(auction => {
        const date =
          auction.eventStatus === 'EventPostponed'
            ? 'Postponed'
            : auction.subEvents?.length &&
              getEventDateAverage(auction.subEvents);
        return { label: `${auction.name} - ${date}`, selected: false };
      });
  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  const internal = location?.state?.internal || false;
  useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault(); // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById('my-component');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    // remove the event listener when the component is unmounted

    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  if (typeof window !== 'undefined') {
    document.addEventListener('contextmenu', e => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
  useEffect(() => {
    if (internal) {
      executeScroll();
    }
  }, []);

  const populateCard = row => {
    return (
      <div
        style={{ 'pointer-events': 'none' }}
        id="my-component"
        className={styles.newsCard}
      >
        <GatsbyImage
          image={row.image}
          className={styles.img}
          alt={row.imageDescription || ''}
        />
        <div>
          <h3>{row.title}</h3>
          <p>{row.description}</p>
          <Button type="app-transparent-no-border-button">READ MORE</Button>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div ref={myRef} className={styles.releasesSection}>
        <div className={styles.rightSection}>
          <Filters selectedTab={tab} />

          <div className={styles.newsWrapper}>
            {posts?.map((row, index) =>
              tab && tab === PRESS.news ? (
                <a href={row.url} key={index}>
                  {populateCard(row)}
                </a>
              ) : (
                <Link to={row.url} key={index}>
                  {populateCard(row)}
                </Link>
              )
            )}
            <div>
              <Pagination
                currentPage={pageNumber || 1}
                totalPage={totalNumberOfPages || 1}
                itemsCountPerPage={PRESS.newsArticlesPerPage}
                onPageChange={changePage}
              />
            </div>
          </div>
        </div>

        <div className={styles.pressInfo}>
          <div className={styles.credentials}>
            <h2>Press Credentials</h2>
            {auctions?.length > 0 && (
              <Button
                type="app-transparent-red-button"
                handleClick={() => navigate('/request-credentials')}
              >
                Request Auction Credentials
              </Button>
            )}
            <Button
              type="app-transparent-red-button"
              handleClick={() => navigate('/media-mailing-list')}
            >
              Add to Media Mailing List{' '}
            </Button>
          </div>
          <Contact contactData={pageData} />
          <Bio bio={bio} />
        </div>
      </div>
    </Fragment>
  );
};

export default News;
